import style from "./BackButton.module.scss"

type Props = {
	onClick?: () => void
	ariaLabel?: string
	/**
	 * Rename-proof handle for the automated tests, which otherwise have only the aria label — prose
	 * that is free to change. The whole sidebar lives in the Apryse web component's open shadow root,
	 * so it is reachable by CSS/role locators but NOT by XPath.
	 */
	testId?: string
}

export const BackButton = ({ onClick, ariaLabel = "Go back", testId = "back-button" }: Props) => {
	return (
		<button
			type="button"
			className={style.backButton}
			onClick={onClick}
			aria-label={ariaLabel}
			data-testid={testId}
		>
			<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M10 12L6 8L10 4"
					stroke="currentColor"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</button>
	)
}
